import { put, race, take } from 'redux-saga/effects';

import { types, makeAssemblyModal } from './actions';

export function* makeAssemblyModalFlow({
  shouldAskAboutOps,
  shouldAskAboutMakeSupportingFile,
}) {
  yield put(
    makeAssemblyModal.open({
      shouldAskAboutOps,
      shouldAskAboutMakeSupportingFile,
    }),
  );

  const { confirm } = yield race({
    confirm: take(types.MAKE_ASSEMBLY_MODAL_CONFIRM),
    close: take(types.MAKE_ASSEMBLY_MODAL_CLOSE),
  });

  if (confirm) {
    return confirm.payload;
  } else {
    return null;
  }
}
